import React from 'react';
import classnames from 'classnames';
import styles from './styles.styl';

const Modal = props => {
  const { onOverlayClick, children, isWide } = props;
  return (
    <div className={styles.container}>
      <div className={styles.overlay} onClick={onOverlayClick} />
      <div className={classnames(styles.modal, { [styles.wide_modal]: isWide })}>
        {children}
      </div>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/Modal/index.js